import React from 'react';
import BannerSection from "../components/BannerSection";
import WelcomeSection from '../components/WelcomeSection';
import CoursesSection from '../components/CoursesSection';
import FacilitiesSection from '../components/FacilitiesSection';
import ReviewSection from '../components/ReviewSection';
import ContactSection from '../components/ContactSection';

const Home = () => {
  return (
    <>
      <BannerSection />
      <WelcomeSection />
      <CoursesSection />
      <FacilitiesSection />
      <ReviewSection />
      <ContactSection />
    </>
  );
};

export default Home;